import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
    selector: 'ms-modal-cover',
    template: '',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalCoverComponent {
    @HostBinding('class') className = 'modal-gestures-cover';
}
